import crypto from 'crypto';
export function getSubtle() {
    const subtle = crypto.webcrypto.subtle;
    if (!subtle) {
        const url = 'https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto';
        throw new Error(`SubtleCrypto not supported. This feature is available only in Node 16+. ${url}`);
    }
    return subtle;
}
export function computeMd5(input) {
    return crypto.createHash('md5').update(input).digest();
}
export function computeSha1(input) {
    return crypto.createHash('sha1').update(input).digest();
}
export function createCipheriv(algorithm, key, iv) {
    return crypto.createCipheriv(algorithm, key, iv);
}
export function createDecipheriv(algorithm, key, iv) {
    return crypto.createDecipheriv(algorithm, key, iv);
}
export function publicEncrypt(publicKey, buffer) {
    return crypto.publicEncrypt(publicKey, buffer);
}
export function privateDecrypt(privateKey, buffer) {
    return crypto.privateDecrypt(privateKey, buffer);
}
//# sourceMappingURL=crypto.js.map